import { render, staticRenderFns } from "./PostSearchHeader.vue?vue&type=template&id=3c96d380&scoped=true&"
var script = {}
import style0 from "./PostSearchHeader.vue?vue&type=style&index=0&id=3c96d380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c96d380",
  null
  
)

export default component.exports